also <template>
  <div class="oee-item"
       :class="getMachineStatus">
    <div class="header" :class="getMachineStatus">

      <span>{{ getWorkflowName(item.id).substring(0, 6) }} </span>
    </div>
    <apexchart
        v-show="getOeeLast"
        class="oee-doughnut"
        type="radialBar"
        height="97px"
        width="64px"
        :options="getOptions"
        :series="getOeeLast()"/>


    <span class="footer text-center " :class="getMachineStatus"
          v-if="getActiveDownTimesForWorkflow(this.item.id).length"> {{
        totalDownTime
      }}</span> <span class="footer text-center" v-if="getMachineStatus === 'idle'"> </span>
    <span class="footer text-center"
          v-if="!getActiveDownTimesForWorkflow(this.item.id).length">   {{
        actualCycleTime == 0 ? '-' : actualCycleTime
      }} {{ $t('time.per' + getOeeConfig.cycleTime.timePerProduct) }}
   </span>

  </div>

</template>

<script>
import {mapGetters, mapMutations} from "vuex";

import timeCalc from "@/mixins/timeCalc";
import {getAvailability, getPerformance, getQuality} from '../../../util/oeeData'
import oeeCalculations from "@/mixins/oeeAnalytics/oeeCalculations";
import timeUtils from "mout/time";

const COLORS = {
  idle: '#ADB5BD',
  running: '#3EC27C',
  downtime: '#C23E3E',
  'downtime downtime-outplanned': '#ADB5BD',
  underperforming: '#FFCC5B',
  badperforming: '#C23E3E',
}
export default {
  name: "floorplanOee",
  props: ['item','rerender'],
  mixins: [timeCalc, oeeCalculations],
  data() {
    return {

      loading: false,
      availability: 0,
      performance: 0,
      oee: 0,
      amountProduced: 0,
      productCycleTimeTimestamp: null,
      actualCycleTime: 0,
      // electricity:{}
    }
  },
  firestore() {
    return {
      // electricity:this.$FB.collection('workflowElectricity').doc(this.item.id)
    }
  },
  computed: {
    ...mapGetters(['getTime']),
    ...mapGetters('users', ['getClaims']),
    ...mapGetters('productionRuns', ['getProductionRunsOfWorkflow', 'getProductionRun']),
    ...mapGetters('workflows', ['getWorkflowName']),

    ...mapGetters('downTimes', ['getActiveDownTimesForWorkflow', 'getDowntimesBetweenTimestamps']),
    ...mapGetters('periodicProductivityLogs', ['getLogsBetweenTimestamps', 'getAmountProducedBetweenTimestamps']),
    ...mapGetters('company', ['getConfig', 'getProductNumberKey', 'getNpcKey', 'getOeeConfig', 'getOEETimeFrameView']),
    getValue() {
      return this.getOeeLast()
    },
    getElectricity() {
      if (this.electricity.kva) {
        return this.electricity.kva.toFixed(0)
      } else {
        return null
      }
    },
    getRunTime() {
      let activeJob = this.getProductionRunsOfWorkflow(this.item.id)[0]
      if (!activeJob || !activeJob.job) {
        return "0"
      }

      let target = activeJob.job.target

      let runTime = this.getTime.diff(activeJob.productionStart)


      return (runTime / target * 100)
    },

    getLogsFromWorkflow() {
      this.getProductionRunsOfWorkflow(this.item.id)
      let cycleTimeConfig = this.getOeeConfig.cycleTime
      let amountProducedinMinutes = this.getAmountProducedBetweenTimestamps(this.getTime.clone().subtract(cycleTimeConfig.timeFrame.value, cycleTimeConfig.timeFrame.unit), this.getTime, this.item.id)

      return amountProducedinMinutes
    },
    getMachineStatus() {
      let downTimeActive = this.getActiveDownTimesForWorkflow(this.item.id)
      let runActive = this.getProductionRunsOfWorkflow(this.item.id).length
      let oeeValue = this.getValue
      if (downTimeActive.length) {
        if (downTimeActive[0].reason.length < 1 || downTimeActive[0].type == 'unplanned') {
          return 'downtime'
        } else if (downTimeActive[0].type == 'out-planned') {
          return 'downtime downtime-outplanned'
        } else {

          return 'badperforming'
        }
      } else if (runActive) {
        if (oeeValue >= 90) {
          return 'running'
        } else if (oeeValue >= 60 && oeeValue < 90) {
          return 'underperforming'
        } else {
          return 'badperforming'
        }
      } else {
        return 'idle'
      }
    },
    amountProducedPerc() {
      let runActive = this.getProductionRunsOfWorkflow(this.item.id)[0]
      return runActive && runActive.job ? ((runActive.amountProduced / runActive.job.amount) * 100).toFixed(0) : 0
    },
    currentProductionRun() {
      let runActive = this.getProductionRunsOfWorkflow(this.item.id)[0]
      if (!runActive) {
        return null
      } else {
        return runActive.downTimeIndicator.toDate()
      }
    },
    totalDownTime() {
      let downTimeActive = this.getActiveDownTimesForWorkflow(this.item.id)[0]
      return this.formattedColonTime(this.getTime.diff(downTimeActive.downTimeIndicator, 'ms'))
    },
    textColor() {
      return this.getMachineStatus !== 'downtime' ? 'black' : 'white'
    },
    getOptions() {
      return {
        colors: [COLORS[this.getMachineStatus]],
        chart: {
          width: "64px",
          height: "97px",
          offsetX: -3,
          offsetY: 0,
          id: this.item.id
        },
        plotOptions: {
          radialBar: {
            hollow: {
              size: "40%"
            },
            dataLabels: {
              showOn: "always",
              name: {
                offsetY: 3,
                show: this.getMachineStatus === 'idle' ? true : false,
                color: this.textColor,
                fontSize: "12px"
              },
              value: {
                offsetY: 5,
                color: this.textColor,
                fontWeight: 700,
                fontSize: "12",
                show: this.getMachineStatus !== 'idle' ? true : false
              }
            },
          },
        },
        labels: [this.getMachineStatus === 'idle' ? 'idle' : ''],
      };

    },

  },
  methods: {
    ...mapMutations('floorPlans', ['addLoadingComponent', 'removeLoadingComponent']),
    handleClick() {
      let status = this.getMachineStatus
      if (status === 'downtime') {
        let downTimeActive = this.getActiveDownTimesForWorkflow(this.item.id)[0]
        this.$router.push('/downtimes/' + downTimeActive.id)
      } else {
        this.$store.commit('users/selectedWorkflow', this.item.id)
        this.$router.push('/operator-interface')
      }
    },

    getOeeLast() {
      return [this.oee]
    },
    async getData() {
      this.loading = true

      this.addLoadingComponent(this._uid)
      const self = this

      let {startDateTime, endDateTime} = this.getOEETimeFrameView(this.item.id)
      let baseQuery = {from: startDateTime, to: endDateTime, workflowId: this.item.id,  useShiftsPerWorkflowTable: true}
      let promises = [getAvailability(baseQuery), getPerformance({
        ...baseQuery, unit: 'day',
        productNumberKey: this.getProductNumberKey,
        npcKey: this.getNpcKey
      }), getQuality(baseQuery)]
      let result = await Promise.all(promises)
      this.availability = result[0]
      this.performance = result[1]
      this.quality = result[2]

      let oee = Math.round((this.availability.data.overall.availability * this.performance.data.overall.performance * this.quality.data.overall.quality) * 100)

      this.oee = oee

      self.$emit('oeeData', {
        workflowId: this.item.id,
        availability: this.availability ? this.availability.data : [],
        performance: this.performance.data ? this.performance.data : [],
        quality: this.quality ? this.quality.data : [],
        oee: this.oee
      })
      this.loading = false
      this.removeLoadingComponent(this._uid)
      // setTimeout(()=>{
      //   console.log('called')
      // },1000)
      return oee
    }
  },
  watch: {
    currentProductionRun(newV, oldV) {
      this.actualCycleTime = moment(newV).diff(oldV, 'seconds')
      if (isNaN(this.actualCycleTime)) {
        this.actualCycleTime = 0
      }
      this.$emit('cycleTime', {workflowId: this.item.id, cycleTime: this.actualCycleTime})
    },
  },
  beforeDestroy() {
     clearInterval(this.interval)
  },
  async created() {
    let where = [
      ['companyId', '==', this.getClaims.companyId],
      ['startTime', '>=', moment().subtract(1, 'hour').startOf('hour').toDate()],
    ];

    await this.$store.dispatch('periodicProductivityLogs/openDBChannel', {where});
    this.$emit('cycleTime', {workflowId: this.item.id, cycleTime: 0})
    if (!this.interval) {
       this.interval = setInterval(() => {
        this.getData()
       }, 10000 * 60 * 3) // every 10 min
    }
    await this.getData()

  },
  mounted() {
  }
}
</script>

<style lang="scss" scoped>
$green: #3EC27C;
$yellow: #FFCC5B;
$red: #C23E3E;
$idle: #ADB5BD;

.oee-item {

  cursor: pointer;
  border-radius: 8px;
  background: #F8F9FA;
  width: 64px;
  height: 97px !important;
  color: black;

  &.downtime {
    color: white;
    background: lighten($red, 15);
  }

  .header {
    border-radius: 8px 8px 0 0;
    color: white;
    width: 64px;
    height: 30px;

    span {
      z-index: 50000;
      font-size: 14px;
      font-weight: 700;
      position: absolute;
      top: 5px;
      width: 100%;
      text-align: center;
    }

    &.running {
      background: $green;
    }

    &.downtime {
      background: $red;
    }

    &.badperforming {
      background: $red;
    }

    &.underperforming {
      background: $yellow;
    }

    &.idle {
      background: $idle;
    }
  }

  &.downtime-outplanned {
    .header {
      background: $idle;
    }

    background: #F8F9FA;
  }
}


.oee-doughnut {
  top: 20px;
  position: absolute;
}

::v-deep  span.footer {
  color: #000000;
  z-index: 50000;
  font-size: 12px;
  height:auto !important;
  position: absolute !important;
  width: 100%;
  bottom: 1px;

  &.downtime {
    color: white;
  }

  &.downtime-outplanned {
    color: black;
  }

}


</style>